/**
 * Stock transfers layout guard — Layer 3 of the module gate (ADR-0046).
 *
 * Stock transfers are the 1.0-withheld `stock-ops` module (a single factory runs
 * one store in month one; returns in 1.2). Stock / warehouses / adjustments stay
 * in. This layout route redirects a typed `/inventory/stock-transfers` URL — and
 * every nested child (`/inventory/stock-transfers/new`) — to `/` unless the
 * workspace is entitled to `stock-ops`, which no 1.0 plan grants. Renders only
 * an `<Outlet/>`.
 * @see docs/adr/0046-withheld-1.0-modules.md
 */
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireModule } from "../../../../features/workspace/index.ts";

export const Route = createFileRoute("/(workspace)/inventory/stock-transfers")({
  beforeLoad: requireModule("stock-ops"),
  component: Outlet,
});
